import React, { ReactNode } from "react";
import { SharedCurrentUser } from "../../../lib/types";

import CircleErrorIcon from "../../icons/CircleErrorIcon";
import RandomColorAvatar from "../RandomColorAvatar";

import { Avatar, Box, HStack, MenuButton } from "@chakra-ui/react";

const hoverStyle = { backgroundColor: "#EDF5F3" };

export const Profile = ({ currentUser }: { currentUser: NonNullable<SharedCurrentUser> }) => {
  const Wrapper = ({ children }: { children: ReactNode }) => {
    return (
      <MenuButton h="full" display="flex" _hover={hoverStyle} px={4}>
        <HStack gap={2}>{children}</HStack>
      </MenuButton>
    );
  };
  if (currentUser.is_all_public_feature_accessible) {
    return (
      <Wrapper>
        <RandomColorAvatar
          src={currentUser.profile_image_url}
          bgColor={currentUser.real_name_avatar_bgcolor}
          name={currentUser.full_name}
          boxSize={8}
          sx={{ "--avatar-font-size": "1rem" }}
        />
        <Box as="span" fontSize="sm">
          {currentUser.full_name}
        </Box>
      </Wrapper>
    );
  } else if (currentUser.latest_personal_info_application_rejected) {
    return (
      <Wrapper>
        <Box position="relative">
          <Avatar boxSize={8} />
          <Box
            position="absolute"
            bottom="-4px"
            right="-4px"
            bg="white"
            borderRadius="full"
            p="1px"
            boxSize="18px"
            display="flex"
            alignItems="center"
            justifyContent="center"
          >
            <CircleErrorIcon boxSize="14px" />
          </Box>
        </Box>
        <Box textAlign="left">
          <Box fontSize="sm">{currentUser.full_name}</Box>
          <Box fontSize="xs" color="text.caution.dark" fontWeight="bold">
            申請内容に修正が必要です
          </Box>
        </Box>
      </Wrapper>
    );
  } else if (!currentUser.personal_info_applicationing) {
    return (
      <Wrapper>
        <Avatar boxSize={8} />
        <Box fontSize="sm">{currentUser.email}</Box>
      </Wrapper>
    );
  } else {
    return (
      <Wrapper>
        <Avatar boxSize={8} />
        <Box fontSize="sm">{currentUser.full_name}</Box>
      </Wrapper>
    );
  }
};
